var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-col',{attrs:{"cols":"12"}},[(_vm.errors.length)?_c('div',[_c('b-alert',{attrs:{"show":"","dismissible":""}},_vm._l((_vm.errors),function(error){return _c('p',{key:error,staticClass:"mb-0"},[_vm._v(_vm._s(error))])}),0)],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }